<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename"><span class="c8-titlename__text">形态走势</span></div>
      </div>
      <div class="content-8__titlebar__right">
        <LotteryDateFilterTab
          @updateForm="updateForm"
        />
      </div>
    </div>
    <Loading v-if="isLoading" />
    <div v-if="trendList.length > 0 && !isLoading">
      <LotteryPresentSelector
        @changePresent="changePresent"
      />

      <div class="content-8__controlbar__item">
        <div class="c8-select">
          <div class="c8-select__title">
            <span class="c8-select__title__text" v-text="hmTitle"></span>
          </div>
          <div class="c8-select__content">
            <a
              v-for="item in typeList"
              :key="item.value"
              class="button-outline c8-select__content__item"
              :class="{ active: item.value == currentType }"
              href="javascript:;"
              @click="changeType(item.value)"
            >
              <span class="button-outline__text" v-text="item.label"></span>
            </a>
          </div>
        </div>
      </div>

      <div class="content-8__content">
        <div class="table-scroll">
          <table style="position:relative" draw-root>
            <!-- 形态走勢 -->
            <thead>
              <tr>
                <th rowspan="2">期号</th>
                <th rowspan="2">开奖号码</th>
                <th v-for="type in typeHead" :key="type.value" colspan="10">{{ type.label }}</th>
                <th colspan="5">形态</th>
                <th colspan="3">组选类型</th>
              </tr>
              <tr>
                <th
                  v-for="(num, index) in numList"
                  :key="`num-${num.key}-${index}-${num.label}`"
                  v-text="num.label"
                >
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(trendItem,trendIndex) in trendList" :key="`trend-${trendItem.period}`" :class="{ 'tr-bottom-border': presentLineDivided && !((trendIndex + 1) % 5) }">
                <td v-text="trendItem.period"></td>
                <td>
                  <div class="continuous-text">
                    <span
                      v-for="(ball, ballIndex) in trendItem.balls"
                      :key="`trend-${trendItem.period}-${ballIndex}`"
                      class="continuous-text__text red"
                      v-text="`${ball} `"
                    ></span>
                  </div>
                </td>
                <td
                  v-for="{ key: numKey } in numList"
                  :key="`num-${numKey}`"
                  :set="item = trendItem.missing[currentHm][numKey] /* for shorten html */"
                  :class="{
                    'bg-col': trendItem.missing[currentHm][numKey].drawType.indexOf('hm') > -1,
                    'yiloufc': presentLineMissingLayer && trendItem.missing[currentHm][numKey].isMissingLayer,
                    'bg-red': trendItem.missing[currentHm][numKey].isRed,
                    'bg-blue': trendItem.missing[currentHm][numKey].isBlue,
                    'bg-orange': trendItem.missing[currentHm][numKey].isOrange,
                    'bg-col-red': trendItem.missing[currentHm][numKey].isColRed,
                    'bg-col-blue': trendItem.missing[currentHm][numKey].isColBlue,
                    'bg-col-green': trendItem.missing[currentHm][numKey].isColGreen,
                    'isDraw': trendItem.missing[currentHm][numKey].isDraw
                  }"
                >
                  <div v-if="item.drawType.indexOf('hm') > -1" class="tableballbox">
                    <div class="tableballbox__item">
                      <div class="ball circle  size-middle" :class="{'color--blue':trendItem.missing[currentHm][numKey].isDraw}">
                        <span
                          v-show="item.isDraw || presentMissing"
                          class="ball__number"
                          v-bind="item.drawMap"
                          v-text="item.label"
                        ></span>
                      </div>
                    </div>
                  </div>
                  <span
                    v-else
                    v-show="item.isDraw || presentMissing"
                    v-bind="item.drawMap"
                    v-text="item.label"
                  ></span>
                </td>
              </tr>
            </tbody>

            <!-- 数据统计 -->
            <thead statistic-dom>
              <tr>
                <th colspan="2" rowspan="2">
                  数据统计
                  <statisticTip />
                </th>
                <th v-for="type in typeHead" :key="type.value" colspan="10">{{ type.label }}</th>
                <th colspan="5">形态</th>
                <th colspan="3">组选类型</th>
              </tr>
              <tr>
                <th
                  v-for="(num, index) in numList"
                  :key="`num-${num.key}-${index}-${num.label}`"
                  v-text="num.label"
                >
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="statisticItem in statisticList"
                :key="`statistic-${statisticItem.statisticType}`"
              >
                <td colspan="2" v-text="statisticItem.label"></td>
                <td
                  v-for="(num, index) in numList"
                  :key="`statistic-num-${num.key}-${index}`"
                  v-text="statisticItem.data[currentHm][num.key]"
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <NoData v-if="trendList.length === 0 && !isLoading" />
  </div>
</template>

<script>
import {
  commonTrendMethods_web,
  drawTrendCanvas,

  basicNumList,
  basicHmList,
  hmList,
  presentSelectorComputedVariable
} from '@/utils/flyc-temp/lotteryLib'

import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
import LotteryPresentSelector from '@/components/web/common/LotteryPresentSelector'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
import statisticTip from '@/components/web/common/statisticTip'
// ssc

export default {
  name: 'WebXingTaiZouShih', // 形态走勢
  components: {
    LotteryPresentSelector,
    LotteryDateFilterTab,
    Loading,
    NoData,
    statisticTip
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code,

      // 組出這個頁面會用到的api
      trendTypes: ['basicTrend', 'singTai', 'zuSyuan'],

      form: {
        count: 30
      },

      trendList: [],
      currentHm: 'all',

      statisticSort: ['appearCount', 'avgMissing', 'now', 'biggestContinue', 'biggestMissing'],
      statisticList: [],
      numList: [],
      typeList: [
        {
          label: '前三形态',
          value: 'front'
        },
        {
          label: '中三形态',
          value: 'middle'
        },
        {
          label: '后三形态',
          value: 'back'
        }
      ],
      typeHead: [
        {
          label: '第一球号码走势',
          value: '1'
        },
        {
          label: '第二球号码走势',
          value: '2'
        },
        {
          label: '第三球号码走势',
          value: '3'
        }
      ],
      currentType: 'front',
      present: {
        presentMissing: false,
        presentLine: false,
        presentLineDivided: false,
        presentLineMissingLayer: false
      },
      isLoading: true
    }
  },
  computed: {
    ...basicNumList,
    ...basicHmList,
    ...hmList, // TODO: 這裡的numList 會不會其實和api 一樣放個兩層的會比較好?
    ...presentSelectorComputedVariable,

    hmTitle() {
      return this.lotteryType === 'pk10' ? '筛选名次: ' : '筛选球位: '
    },

    // 用來畫canvas 的key
    lineArray() {
      return ['hm1', 'hm2', 'hm3', 'hm4', 'hm5']
    }
  },
  watch: {
    currentHm(currentHm) {
      this.removeMultipleTrendCanvas()
      if (this.presentLine) {
        this.drawMultiTrendCanvas()
      }
    },

    presentLine(presentLine) {
      if (presentLine) {
        this.drawMultiTrendCanvas()
        return
      }
      this.removeMultipleTrendCanvas()
    }
  },
  async created() {
    this.getNumList()
    await this.getTrendData()
    this.isLoading = false
    if (!this.trendList.length) return

    this.$nextTick(() => {
      if (this.trendList.length && this.presentLine) this.drawMultiTrendCanvas()
    })
  },
  mounted() {
    window.vm = this
  },
  updated() {
    this.initLazyLoading()
  },
  methods: {
    async changeType(val) {
      this.isLoading = true
      this.removeMultipleTrendCanvas()
      this.currentType = val
      this.getNumList()
      await this.getTrendData()
      this.isLoading = false
      this.drawMultiTrendCanvas()
    },
    getNumList() {
      const list = []
      switch (this.currentType) {
        case 'front' :
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm1_num${j}`
            list.push({ label, key })
          }
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm2_num${j}`
            list.push({ label, key })
          }
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm3_num${j}`
            list.push({ label, key })
          }
          list.push(
            {
              label: '豹子',
              key: 'group1_puke_baoZih'
            },
            {
              label: '顺子',
              key: 'group1_puke_shunZih'
            },
            {
              label: '对子',
              key: 'group1_puke_dueiZih'
            },
            {
              label: '半顺',
              key: 'group1_puke_banShun'
            },
            {
              label: '杂六',
              key: 'group1_puke_zaLiou'
            }
          )
          list.push(
            {
              label: '组三',
              key: 'group1_zuSyuan_zuSan'
            },
            {
              label: '组六',
              key: 'group1_zuSyuan_zuLiou'
            },
            {
              label: '豹子',
              key: 'group1_zuSyuan_baoZih'
            }
          )
          this.typeHead = [
            {
              label: '第一球号码走势',
              value: '1'
            },
            {
              label: '第二球号码走势',
              value: '2'
            },
            {
              label: '第三球号码走势',
              value: '3'
            }
          ]
          break
        case 'middle':
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm2_num${j}`
            list.push({ label, key })
          }
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm3_num${j}`
            list.push({ label, key })
          }
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm4_num${j}`
            list.push({ label, key })
          }
          list.push(
            {
              label: '豹子',
              key: 'group2_puke_baoZih'
            },
            {
              label: '顺子',
              key: 'group2_puke_shunZih'
            },
            {
              label: '对子',
              key: 'group2_puke_dueiZih'
            },
            {
              label: '半顺',
              key: 'group2_puke_banShun'
            },
            {
              label: '杂六',
              key: 'group2_puke_zaLiou'
            }
          )
          list.push(
            {
              label: '组三',
              key: 'group2_zuSyuan_zuSan'
            },
            {
              label: '组六',
              key: 'group2_zuSyuan_zuLiou'
            },
            {
              label: '豹子',
              key: 'group2_zuSyuan_baoZih'
            }
          )
          this.typeHead = [
            {
              label: '第二球号码走势',
              value: '2'
            },
            {
              label: '第三球号码走势',
              value: '3'
            },
            {
              label: '第四球号码走势',
              value: '4'
            }
          ]
          break
        case 'back':
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm3_num${j}`
            list.push({ label, key })
          }
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm4_num${j}`
            list.push({ label, key })
          }
          for (let j = 0; j < 10; j++) {
            const label = j
            const key = `hm5_num${j}`
            list.push({ label, key })
          }
          list.push(
            {
              label: '豹子',
              key: 'group3_puke_baoZih'
            },
            {
              label: '顺子',
              key: 'group3_puke_shunZih'
            },
            {
              label: '对子',
              key: 'group3_puke_dueiZih'
            },
            {
              label: '半顺',
              key: 'group3_puke_banShun'
            },
            {
              label: '杂六',
              key: 'group3_puke_zaLiou'
            }
          )
          list.push(
            {
              label: '组三',
              key: 'group3_zuSyuan_zuSan'
            },
            {
              label: '组六',
              key: 'group3_zuSyuan_zuLiou'
            },
            {
              label: '豹子',
              key: 'group3_zuSyuan_baoZih'
            }
          )
          this.typeHead = [
            {
              label: '第三球号码走势',
              value: '3'
            },
            {
              label: '第四球号码走势',
              value: '4'
            },
            {
              label: '第五球号码走势',
              value: '5'
            }
          ]
          break
      }
      this.numList = list
    },
    getLineArray() {
      const { currentType } = this
      switch (currentType) {
        case 'front':
          return ['hm1', 'hm2', 'hm3']
        case 'middle':
          return ['hm2', 'hm3', 'hm4']
        case 'back':
          return ['hm3', 'hm4', 'hm5']
        default:
          console.warn('getLineArray: 對應currentType 失敗! 將使用空陣列.', currentType)
          return []
      }
    },
    ...commonTrendMethods_web,
    ...drawTrendCanvas,
    afterFormatTrendData(list) {
      list.forEach((item) => {
        Object.keys(item.missing.all).forEach((numKey) => {
          const hm = Number(numKey.split('_num')[0].split('hm')[1])

          if (hm % 3 === 0) {
            item.missing.all[numKey].isColRed = true
          } else if (hm % 3 === 1) {
            item.missing.all[numKey].isColBlue = true
          } else if (hm % 3 === 2) {
            item.missing.all[numKey].isColGreen = true
          }
        })
      })
      return list
    }

  }
}
</script>

<style lang="scss" scoped>
  .continuous-text {
    width:250px;
  }
  .fn-content-8__controlbar__item {
    align-items: flex-start;
  }
</style>
